/** @format */

import {Box, Typography} from '@mui/material';
import {Trans} from 'react-i18next';

import {SectionTitle} from '../../styles';
import {MonitoringStubContainer} from './styles';
import StubIllustration from './images/stub.svg?react';

const MonitoringStub = () => {
  return (
    <MonitoringStubContainer>
      <SectionTitle>
        <Trans>Результаты мониторинга</Trans>
      </SectionTitle>
      <Typography
        variant='body2'
        sx={{
          color: theme => theme.palette.semantic_dark?.surface.onSurface,
          fontSize: '14px',
          lineHeight: '16px',
        }}
      >
        <Trans>
          Задайте правила мониторинга и его результаты будут появляться здесь каждый месяц
        </Trans>
      </Typography>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          mt: 4,
        }}
      >
        <StubIllustration style={{margin: 'auto'}} />
      </Box>
    </MonitoringStubContainer>
  );
};

export default MonitoringStub;
